module.exports = __webpack_public_path__ + "img/onboarding_clipboard.3890198e.png";